import { DispatchLoading, DispatchType } from "domain/utils/ReactUtils";
import { PagarPedidoService } from "../../services/pagarPedido/pagarPedidoService";
import { StoreAplication } from "base/src/main";
import { CampanhaPedidoResgatePagamentoDepositoResponse } from "../../types/pagarPedido/campanhaPedidoResgatePagamentoDepositoResponse";
import { toast } from "react-toastify";
import { EnviarEmailNotaRepasseRequest } from "../../types/pagarPedido/EnviarEmailNotaRepasseRequest";
import { GerarBoletoResponse } from "../../types/lotePedido/gerarBoletoResponse";
import { DuploFatorRequest } from "../../types/pagarPedido/duploFator";
import ValidationResult from "domain/types/global/validationResult";
import { GerarPixResponse } from "../../types/lotePedido/gerarPixResponse";

export const OBTER_NOTA_REPASSE = 'OBTER_NOTA_REPASSE'
export const OBTER_BOLETO = 'OBTER_BOLETO'
export const GERAR_BOLETO = 'GERAR_BOLETO'
export const ENVIAR_EMAIL_NOTA = 'ENVIAR_EMAIL_NOTA'
export const ENVIAR_CODIGO_WHATSAPP = 'ENVIAR_CODIGO_WHATSAPP'
export const PAGAMENTO_PIX_CAMPANHA = 'PAGAMENTO_PIX_CAMPANHA'

export default class PagarPedidoContainer {
  private service: PagarPedidoService;

  constructor() {
    this.service = new PagarPedidoService();
  }

  async obterNotaRepasse(campanhaPedidoResgatePagamentoId: number): Promise<string | Error> {
    StoreAplication.dispatch(DispatchLoading(OBTER_NOTA_REPASSE, DispatchType.LOADING, undefined, undefined, () => this.obterNotaRepasse(campanhaPedidoResgatePagamentoId)));
    const result = await this.service.obterNotaRepasse(campanhaPedidoResgatePagamentoId, OBTER_NOTA_REPASSE);
    StoreAplication.dispatch({
      type: OBTER_NOTA_REPASSE
    });
    return result
  }

  async obterBoleto(campanhaPedidoResgatePagamentoId: number): Promise<CampanhaPedidoResgatePagamentoDepositoResponse | Error> {
    StoreAplication.dispatch(DispatchLoading(OBTER_BOLETO, DispatchType.LOADING, undefined, undefined, () => this.obterBoleto(campanhaPedidoResgatePagamentoId)));
    const result = await this.service.obterBoleto(campanhaPedidoResgatePagamentoId, OBTER_BOLETO);
    StoreAplication.dispatch({
      type: OBTER_BOLETO
    });
    return result
  }

  async gerarBoleto(campanhaPedidoResgatePagamentoId: number, carteiraId: number): Promise<GerarBoletoResponse | Error> {
    StoreAplication.dispatch(DispatchLoading(GERAR_BOLETO, DispatchType.LOADING, undefined, undefined, () => this.obterBoleto(campanhaPedidoResgatePagamentoId)));
    const result = await this.service.gerarBoleto(campanhaPedidoResgatePagamentoId, carteiraId, OBTER_BOLETO);
    StoreAplication.dispatch({
      type: OBTER_BOLETO
    });
    return result
  }

  async gerarPix(campanhaPedidoResgatePagamentoId: number, carteiraId: number): Promise<GerarPixResponse | Error> {
    StoreAplication.dispatch(DispatchLoading(GERAR_BOLETO, DispatchType.LOADING, undefined, undefined, () => this.obterBoleto(campanhaPedidoResgatePagamentoId)));
    const result = await this.service.gerarPix(campanhaPedidoResgatePagamentoId, carteiraId, OBTER_BOLETO);

    StoreAplication.dispatch({
      type: OBTER_BOLETO
    });
    return result
  }

  async pixCheckSSE(codigoInterno: string, callback?: (success: boolean) => void): Promise<void> {
    //Não vou usar mais pq o Lucas insistiu que o QR Code vai ter validade infinita.
    try {
      const result = await this.service.PixCheckSSE(codigoInterno);

      if (!(result instanceof Error)) {
        StoreAplication.dispatch({
          payload: result,
          type: PAGAMENTO_PIX_CAMPANHA,
        });

        // Chama o callback se fornecido, indicando que o pagamento foi confirmado
        callback?.(true);
      } else {
        callback?.(false);
      }
    } catch (error) {
      callback?.(false);
    }
  }

  resetPix(): void {
    StoreAplication.dispatch({
      payload: undefined,
      type: PAGAMENTO_PIX_CAMPANHA,
    });
  }

  async enviarEmailNotaRepasse(
    campanhaPedidoResgatePagamentoId: number,
    campanhaId: number,
    email: string,
    mensagemAdicional?: string
  ): Promise<boolean> {
    try {
      StoreAplication.dispatch(DispatchLoading(ENVIAR_EMAIL_NOTA, DispatchType.LOADING, 'Enviando e-mail...', undefined));

      const currentUrl = window.location.origin;
      const notaUrl = `${currentUrl}/notaRepasse?CampanhaID=${campanhaId}&CampanhaPedidoResgatePagamentoID=${campanhaPedidoResgatePagamentoId}`;

      const emailRequest: EnviarEmailNotaRepasseRequest = {
        Email: email,
        Link: notaUrl,
        Subject: `Nota de Repasse - Pagamento ID: ${campanhaPedidoResgatePagamentoId}`,
        Message: mensagemAdicional || ''
      };

      const result = await this.service.enviarEmailNotaRepasse(emailRequest, ENVIAR_EMAIL_NOTA);

      if (result instanceof Error) {
        StoreAplication.dispatch(DispatchLoading(ENVIAR_EMAIL_NOTA, DispatchType.ERROR, 'Erro ao enviar e-mail', undefined));
        toast('Erro ao enviar e-mail', { type: 'error' });
        return false;
      }

      StoreAplication.dispatch(DispatchLoading(ENVIAR_EMAIL_NOTA, DispatchType.SUCCESS, 'E-mail enviado com sucesso!', undefined));
      toast('E-mail enviado com sucesso!', { type: 'success' });

      return true;
    } catch (error) {
      StoreAplication.dispatch(DispatchLoading(ENVIAR_EMAIL_NOTA, DispatchType.ERROR, 'Erro ao enviar e-mail', undefined));
      toast('Erro ao enviar e-mail', { type: 'error' });
      return false;
    }
  }

  async enviarCodigoWhatsApp(request: DuploFatorRequest): Promise<ValidationResult | Error> {
    StoreAplication.dispatch(DispatchLoading(ENVIAR_CODIGO_WHATSAPP, DispatchType.LOADING, undefined, undefined, () => this.enviarCodigoWhatsApp(request)));
    const result = await this.service.enviarCodigoWhatsApp(request, ENVIAR_CODIGO_WHATSAPP);
    StoreAplication.dispatch({
      type: ENVIAR_CODIGO_WHATSAPP
    });
    return result;
  }

  clearEmailLoadingState(): void {
    StoreAplication.dispatch({
      type: ENVIAR_EMAIL_NOTA
    });
  }
}